import React, { useCallback, useLayoutEffect, useState } from 'react';
import { Button } from 'design-system/Button';
import { ButtonGroup } from 'design-system/ButtonGroup';
import { RequestActionView } from 'design-system/RequestActionView';
import NavigationCloseButton from 'design-system/NavigationCloseButton';
import useColors from 'hooks/useColors';
import { setSignInSpace } from 'login/actions/signinNavigation';
import { useAppDispatch } from 'store/hooks';
import IconSpace from 'design-system/icons/IconSpace';
import { useJoinSpace } from '../hooks';
import { isWeb } from '../../../constants';
const ModalJoinSpace = ({ route, navigation, }) => {
    const colors = useColors();
    const { spaceName, accessCode } = route.params;
    const dispatch = useAppDispatch();
    const onDismiss = useCallback(() => {
        dispatch(setSignInSpace(undefined));
        navigation.goBack();
    }, []);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerLeft: isWeb
                ? undefined
                : () => (<NavigationCloseButton onPress={onDismiss} colorKey="primary"/>),
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary, colors.text.white, onDismiss]);
    const message = spaceName
        ? `You are invited to join the space named "${spaceName.trim()}"`
        : 'You are invited to join a space!';
    const join = useJoinSpace();
    const [isFetching, setIsFetching] = useState(false);
    const onPress = useCallback(() => {
        join(accessCode, setIsFetching);
    }, [accessCode, join]);
    return (<RequestActionView title="Join Space" subTitle={message} icon={<IconSpace width={54} height={54} gradientKey="ultimate"/>} onDark>
      <ButtonGroup type="floating">
        <Button brand onPress={onPress} title="Join Space" isFetching={isFetching}/>
      </ButtonGroup>
    </RequestActionView>);
};
export default ModalJoinSpace;
